import * as TYPE from '../types';
import axios from 'axios';
import { api } from '../static';
import { toast } from 'react-toastify';

export function signinRequest(formData, setError, router) {
  return async (dispatch) => {
    let response = await axios
      .post(process.env.BASE_URL + api.signin, formData)
      .then((response) => {
        localStorage.setItem('currentPage', 'merchant/merchants');
        // localStorage.setItem('temptoken', response.data.data.token);
        // dispatch({ type: TYPE.SIGNIN_SUCCESS });
        localStorage.setItem('from', 'signin');
        router.push('/verify-otp');
      })
      .catch((err) => {
        if (err?.response?.data?.status_code === 403) {
          router.push('/verify-otp');
          return;
        }
        let errorMsg = err.response && err.response.data ? err.response.data.message : 'Something failed';
        dispatch({
          type: TYPE.SIGNIN_FAIL,
          payload: errorMsg,
        });
        setError({
          password: errorMsg,
        });

        toast.error(errorMsg, {
          position: 'top-center',
          autoClose: 1500,
        });
      });
  };
}

export function Logout(router) {
  return async (dispatch) => {
    let token = localStorage.getItem('token');
    const headers = {
      'Content-Type': 'application/json',
      authorization: token,
    };

    await axios.get(process.env.BASE_URL + api.logout, {
      headers: headers,
    });

    localStorage.clear();
    dispatch({ type: TYPE.LOGOUT });
    dispatch({ type: TYPE.USER_DATA_RESET });
    router.push('/login');
  };
}

export function verifyEmailSendOTP(formData, setError, router) {
  return (dispatch) => {
    axios
      .post(process.env.BASE_URL + api.sendOtp, formData)
      .then((response) => {
        if (response.data.statusCode == 200) {
          localStorage.setItem('currentPage', 'verify-otp');
          dispatch({ type: TYPE.OTP_SENT_TO_RESET_PASSWORD });
          router.push('/verify-otp');
        } else {
          dispatch({ type: TYPE.OTP_SENT_ERROR });
          setError({ email: "E-mail doesn't exist" });
        }
      })
      .catch((error) => {
        dispatch({ type: TYPE.OTP_SENT_ERROR });
        setError({ email: error.response.data.message });
      });
  };
}

export function checkOTP(formData, setError, router) {
  return async (dispatch) => {
    let response = await axios
      .post(process.env.BASE_URL + api.verifyOtp, formData)
      .then((response) => {
        if (response.data.status_code == 201) {
          localStorage.setItem('temptoken', response.data.data.token.token);
          localStorage.setItem('currentPage', 'change-password');
          dispatch({ type: TYPE.OTP_VERIFICATION_SUCCESS });
          router.push('/change-password');
        }
        if (response.data.status_code == 200) {
          localStorage.setItem('currentPage', 'dashboard');
          localStorage.setItem('token', response.data.data.token);
          dispatch({ type: TYPE.SIGNIN_SUCCESS });
          router.push('/');
        } else {
          setError({ otp: response.data.statusMessage || 'Something Failed' });
          dispatch({
            type: TYPE.OTP_VERIFICATION_FAIL,
            payload: 'Something Failed',
          });
        }
      })
      .catch((error) => {
        const errorMessage = error.response.data.statusMessage || 'Something Failed';
        setError({ otp: errorMessage });
        dispatch({
          type: TYPE.OTP_VERIFICATION_FAIL,
          payload: errorMessage,
        });
      });
  };
}

export function passwordReset(formData, setError, router) {
  return (dispatch) => {
    let token = localStorage.getItem('temptoken');
    const headers = {
      'Content-Type': 'application/json',
      token: token,
    };
    axios
      .post(process.env.BASE_URL + api.changePassword, formData, {
        headers: headers,
      })
      .then((response) => {
        dispatch({ type: TYPE.PASSWORD_RESET_SUCCESS });
        router.push('/login');
      })
      .catch((err) => {
        setError((prev) => ({ ...prev, confirm: err.response.data.message }));
      });
  };
}
